import { gql } from "@apollo/client";

//To upload the material in E-Books
export const UPLOAD_MATERIAL = gql`
mutation UploadMultipleMylibraryEbookMaterials(
  $libraryId: UUID!
  $classroomId: UUID!
  $subjectId: UUID!
  $typeName: String!
  $files: JSON!
) {
  uploadMultipleMylibraryEbookMaterials(
    input: {
      pLibraryId: $libraryId
      pClassroomId: $classroomId
      pSubjectId: $subjectId
      pTypeName: $typeName
      pFiles: $files
    }
  ) {
    json
  }
}
`;

//To view materials in E-Books
export const VIEW_ALL_EBOOK_MATERIAL = gql`
query getAllMaterialsForEbookType(
  $lId: UUID!
  $sjId: UUID!
  $searchInput: String = "%"
  $type: String!
  $cId: UUID!
  $limit: Int = null
  $offset: Int = null
  $isclassroom: [Boolean!] = [true, false]
) {
  getMaterialsFromEbookType(
    pClassroomId: $cId
    pLibraryId: $lId
    pSubjectId: $sjId
    pTypeName: $type
    filter: {
      filename: { likeInsensitive: $searchInput }
      fileDeletedAt: { isNull: true }
      or: [
        {
          and: [
            { sharedBy: { isNull: true } }
            { isclassroom: { in: $isclassroom } }
          ]
        }
        {
          and: [
            { sharedBy: { isNull: false } }
            { isclassroom: { equalTo: true } }
          ]
        }
      ]
    }
    first: $limit
    offset: $offset
  ) {
    nodes {
      filename
      filesize
      isclassroom
      typeName
      coverimagepath
      authorname
      filepath
      fileId
      filetype
      feedId
      sharedBy
    }
    totalCount
  }
}
  `;

export const UPDATE_EBOOK_MATERIAL = gql`
mutation updateEbookMaterials($cId:UUID!,$fId:UUID!,$isClassroom:Boolean!,$lId:UUID!,$sjId:UUID!,$type:String!) {
  updateEbookMaterials(
    input: {pClassroomId:$cId, pFileId: $fId, pIsClassroom: $isClassroom, pLibraryId: $lId, pSubjectId: $sjId, pTypeName: $type}
  ) {
    clientMutationId
  }
}`;

export const DELETE_EBOOK_MATERIAL = gql`
mutation deleteEbookMaterials($cId: UUID!, $fId: UUID!, $lId: UUID!, $sjId: UUID!, $type: String!) {
  deleteEbookMaterials(
    input: {pClassroomId: $cId, pFileId: $fId, pLibraryId: $lId, pSubjectId: $sjId, pTypeName: $type}
  ) {
    clientMutationId
  }
}`;

export const CONVERT_PPT_DOCS_TO_PDF = gql`
query convertFileType($key: String) {
  convertFile(key: $key)
}`;


export const VIEW_ALL_MATERIAL_ADMIN = gql `
query GetMylibraryEbooksForAdmin(
  $typeName: String!
  $subjectId: UUID!
  $searchInput: String
  $classroomIds: [UUID!]
  $limit: Int
  $offset: Int
) {
  getMylibraryEbooksForAdmin(
    pTypeName: $typeName
    pSubjectId: $subjectId
    filter: { filename: { likeInsensitive: $searchInput } }
    pClassroomIds: $classroomIds
    first: $limit
    offset: $offset
  ) {
    nodes {
      fileId: fileid
      filename
      filepath
      filesize
      filetype
      isclassroom
      authorname
      coverimagepath
      subjectid
      typeName
    }
    totalCount
  }
}
`

export const UPLOAD_MATERIAL_ADMIN = gql`
  mutation UploadMylibraryEbooksBySchoolAdmin(
  $typeName: String!
  $subjectId: UUID!
  $files: JSON!
  $classroomIds: [UUID!]
) {
  uploadMylibraryEbooksBySchoolAdmin(
    input: {
      pTypeName: $typeName
      pSubjectId: $subjectId
      pFiles: $files
      pClassroomIds: $classroomIds
    }
  ) {
    result: json
  }
}
`;

export const UPDATE_EBOOK_MATERIAL_ADMIN = gql`
  mutation UpdateEbookMaterialsBySchoolAdmin(
    $input: UpdateEbookMaterialsBySchoolAdminInput!
  ) {
    updateEbookMaterialsBySchoolAdmin(input: $input) {
      string
    }
  }
`;

export const DELETE_EBOOK_MATERIAL_ADMIN = gql `
mutation DeleteEbookMaterialsBySchoolAdmin(
  $input: DeleteEbookMaterialsBySchoolAdminInput!
) {
  deleteEbookMaterialsBySchoolAdmin(input: $input) {
    string
  }
}
`
